import { type FC, type SVGProps } from 'react';
import styled, { useTheme } from 'styled-components';

export type ToggleableIconProps = {
	Icon: FC<SVGProps<SVGSVGElement>>;
	IconFilled: FC<SVGProps<SVGSVGElement>>;
	iconSize: number;
	isDisabled?: boolean;
	isSelected: boolean;
	onPressCallback?: () => void;
	testID?: string;
};

export const ToggleableIcon = ({
	Icon,
	IconFilled,
	iconSize,
	isDisabled,
	isSelected,
	onPressCallback,
	testID
}: ToggleableIconProps) => {
	const theme = useTheme();

	const DisabledIcon = () => {
		return (
			<S.IconWrapperDisabled data-testid={testID}>
				<Icon color={theme.colors.backgrounds.main.inverse} height={iconSize} width={iconSize} />
			</S.IconWrapperDisabled>
		);
	};

	const EnabledIcon = () => {
		return (
			<S.IconWrapperTouchable data-testid={testID} onClick={onPressCallback}>
				{isSelected ? (
					<IconFilled color={theme.colors.backgrounds.main.inverse} height={iconSize} width={iconSize} />
				) : (
					<Icon color={theme.colors.backgrounds.main.inverse} height={iconSize} width={iconSize} />
				)}
			</S.IconWrapperTouchable>
		);
	};

	return isDisabled ? <DisabledIcon /> : <EnabledIcon />;
};

namespace S {
	export const IconWrapperTouchable = styled.div`
		border: 1.5px solid ${({ theme }) => theme.colors.backgrounds.main.inverse};
		${({ theme }) => theme.border.radius.large};
		margin-right: ${({ theme }) => theme.spacings.xxsmall};
		padding: 2px;
		cursor: pointer;
	`;

	export const IconWrapperDisabled = styled.div`
		border: 1.5px solid ${({ theme }) => theme.colors.backgrounds.main.inverse};
		${({ theme }) => theme.border.radius.large};
		margin-right: ${({ theme }) => theme.spacings.xxsmall};
		opacity: ${({ theme }) => theme.opacity._40};
		padding: 2px;
	`;
}
